import { z } from 'zod';

import * as api from '@af-fp/api/types.gen';

export const roleSchema = z.enum(['SurveyUser', 'Admin']);

export type Role = z.infer<typeof roleSchema>;

export const profileSchema = z.object({
  id: z.string(),
  roles: z.array(roleSchema),
  name: z.string().nullish(),
  email: z.string().nullish(),
});

export type Profile = z.infer<typeof profileSchema>;

export const getCurrentProfileRequestSchema = z.record(z.string(), z.never());

export type GetCurrentProfileRequest = z.infer<typeof getCurrentProfileRequestSchema>;

export const tokenTypesSchema = z.enum(['Internal', 'Microsoft']);

export type TokenTypes = z.infer<typeof tokenTypesSchema>;

export const oAuthSignInRequestSchema = z.object({
  tokenType: tokenTypesSchema,
  accessToken: z.string().min(1),
});

export type OAuthSignInRequest = z.infer<typeof oAuthSignInRequestSchema>;

export type FeatureToggle = api.FeatureToggleType;
